import {queryOptions, useQuery} from '@github-ui/react-query'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'
import type {ForksApiResponse} from '../types'

function viewerForksQueryOptions(forksApiPath: string) {
  return queryOptions({
    queryKey: ['repo-viewer-forks', forksApiPath],
    queryFn: async () => {
      const response = await verifiedFetchJSON(forksApiPath)

      if (!response.ok) {
        throw new Error('Failed to load forks')
      }

      return (await response.json()) as ForksApiResponse
    },
  })
}

interface UseViewerForksQueryOptions {
  /** API path to fetch the viewer's forks */
  forksApiPath: string
  /** Whether to enable the query (typically tied to dropdown open state) */
  enabled: boolean
}

/**
 * Hook to lazily fetch the viewer's existing forks of a repository.
 * Data is fetched on first dropdown open and cached by React Query.
 */
export function useViewerForksQuery({forksApiPath, enabled}: UseViewerForksQueryOptions) {
  const {data, isLoading, isError} = useQuery({
    ...viewerForksQueryOptions(forksApiPath),
    enabled,
  })

  return {
    forks: data?.forks ?? null,
    isLoading,
    isError,
  }
}
